// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__33-vB","content":"LoadingAlert_content__1NWPs"};